import { useState, useContext } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { PageTitle } from '../../../../_metronic/layout/core';
import * as Utilities from '../../../Components/Utils/Utils';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import Modal from 'react-bootstrap/Modal';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import ActualizarCierreLocatario from "./ActualizarCierreLocatario";
import { SessionContext } from '../../../Components/Context/SessionContext';
import UserIdAuthorized from '../../../api/UserIdAuthorized';
import AgTable from '../../../Components/Table/AgTable';

function ConsultarCierreLocatario({ title }) {

    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [date1, setDate1] = useState(new Date(year, month, 1));

    const [date2, setDate2] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1, date2]);
    const [startDate, endDate] = dateRange;
    let dateFormated1 = startDate ? startDate.getDate() + "/" + ("0" + (startDate.getMonth() + 1)).slice(-2) + "/" + startDate.getFullYear() : null;
    let dateFormated2 = endDate ? endDate.getDate() + "/" + ("0" + (endDate.getMonth() + 1)).slice(-2) + "/" + endDate.getFullYear() : null;

    registerLocale('es', es);

    const tokenn = useGetToken();
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const { session, setSession } = useContext(SessionContext);
    const idLocatario = (localStorage.getItem('idLocatario')) ? localStorage.getItem('idLocatario') : session.idUsuarioLocatario

    const [abirActualizarCierreVentas, setAbirActualizarCierreVentas] = useState(false);
    const [guardadoExitoso, setGuardadoExitoso] = useState(false);

    const [cierreVentasCurrentEdit, setCierreVentasCurrentEdit] = useState(null);

    let header = [
        {
            headerName: 'Nombre Completo',
            field: 'nombreCompleto',
            type: 'rightAligned',
        },
        {
            headerName: 'Suministro',
            field: 'suministro',
        },
        {
            headerName: 'Fecha venta',
            field: 'fechaVenta',
        },
        {
            headerName: 'Fecha registro',
            field: 'registroFecha',
        },
        {
            headerName: 'Ventas (S/)',
            field: 'ventasValor',
            type: 'rightAligned',
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.data.ventasValor, true)}</>
            )
        },
        {
            headerName: 'Transacciones',
            field: 'numeroTransacciones',
            type: 'rightAligned',
        },
        {
            headerName: 'Editar',
            className: 'min-w-50px text-center',
            cellRenderer: (props) => (
                <button className="btn btn-light btn-active-light-primary btn-sm" onClick={
                    function () {
                        setCierreVentasCurrentEdit(props.data);
                        setAbirActualizarCierreVentas(true);
                    }
                } >
                    <i className="fi-rr-interactive"></i>
                </button >
            )
        }
    ];

    function onAfterGuardar(action) {
        setAbirActualizarCierreVentas(false);
        if (action === true) setGuardadoExitoso(true);
    }
    function guardadoExistosoModal() {
        setGuardadoExitoso(false)
        window.location.reload(false);
    }


    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.CONSULTA_CIERRE_LOCATARIO]} >
                <UserIdAuthorized>

                    <PageTitle>
                        {title}
                    </PageTitle>

                    {
                        abirActualizarCierreVentas &&
                        <ActualizarCierreLocatario cierreVentas={cierreVentasCurrentEdit} idLocatario={idLocatario} setSmShow={onAfterGuardar}></ActualizarCierreLocatario>
                    }
                    <div className="card">
                        <div className="card-body pt-6">
                            <div className="d-flex flex-wrap flex-stack mb-6">
                                <div className='d-flex flex-wrap my-2' >
                                    <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                                    <DatePicker
                                        className="form-control form-control-transparent pe-5"
                                        selectsRange={true}
                                        locale="es"
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(dateRange) => {
                                            setDateRange(dateRange);
                                        }}
                                        dateFormat="dd/MM/yyyy"
                                    />
                                </div>
                            </div>
                            <AgTable
                                idContent={"Cierre de Ventas - " + dateFormated1 + " - " + dateFormated2}
                                apiService={Api.CierreVentas_Locatario}
                                setAuxData={null}
                                header={header}
                                titleExcel={"Cierre de Ventas " + dateFormated1 + " / " + dateFormated2}
                                conditions={dateRange[0] != null && dateRange[1] != null}
                                args={{ idLocatario: idLocatario, fechaInicial: dateFormated1, fechaFinal: dateFormated2, token: tokenn }}
                                hideFilter={false}
                                paginationPageSize={8}
                                rowHeight={40}
                            />
                        </div>
                    </div>

                    <Modal
                        size="sm"
                        show={guardadoExitoso}
                        onHide={() => setGuardadoExitoso(false)}
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header>
                            <Modal.Title id="example-modal-sizes-title-sm" style={{ margin: 'auto' }}>
                                Guardado Exitoso
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer style={{ margin: 'auto' }}>
                            <button type="button" className="btn btn-primary" onClick={guardadoExistosoModal}>
                                Aceptar
                            </button>
                        </Modal.Footer>
                    </Modal>

                </UserIdAuthorized>

            </PermissionsGate>
        </>
    )
}

export default ConsultarCierreLocatario;
